// stores/useTempMessagesStore.js
import { create } from "zustand"

const useTempMessagesStore = create((set, get) => ({
  tempMessages: [],

  addTempMessage: (message) =>
    set((state) => ({
      tempMessages: [...state.tempMessages, message],
    })),

  removeTempMessage: (mensagemIdTemporario) => {
    set((state) => ({
      tempMessages: state.tempMessages.filter((msg) => msg.mensagemIdTemporario !== mensagemIdTemporario),
    }))
    return true
  },

  confirmTempMessage: (mensagemIdTemporario) => {
    const found = get().tempMessages.some((msg) => msg.mensagemIdTemporario === mensagemIdTemporario)
    return found
  },

  confirmTempMessageById: (id) => {
    const found = get().tempMessages.find((msg) => msg.id === id)
    return found
  },

  updateTempMessage: (messageId, updates) =>
    set((state) => ({
      tempMessages: state.tempMessages.map((msg) =>
        msg.mensagemIdTemporario === messageId ? { ...msg, ...updates } : msg,
      ),
    })),

  updateTempMessageById: (id, updates) =>
    set((state) => ({
      tempMessages: state.tempMessages.map((msg) => (msg.id === id ? { ...msg, ...updates } : msg)),
    })),

  getTempMessageCreatedAt: (mensagemIdTemporario) => {
    const msg = get().tempMessages.find((m) => m.mensagemIdTemporario === mensagemIdTemporario)
    return msg ? msg.createdAt : null
  },

  resetTemp: () => set({ tempMessages: [] }),
}))

export default useTempMessagesStore
